import { Injectable } from '@angular/core';
import { ExportContext, ExportFileFormat, ExportRange, ExportService } from 'app/layout/export-overlay';
import { buildQuery, page, seed } from '@albatrosdeveloper/ave-utils-npm/lib/utils/query.util';
import { takeUntil } from 'rxjs';
import get from 'lodash-es/get';
import ceil from 'lodash-es/ceil';
import { RouteGroupService } from '../route-group.service';
import RouteGroupAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/routing/route-group/route-group.entity';
import { LOCALIZED_PROPERTIES, ROUTE_GROUP_EXPORT_ID, ROUTE_GROUP_TITLE } from './route-group.constants';

@Injectable()
export class RouteGroupExport {
  constructor(
    private exportService: ExportService,
    private routeGroupService: RouteGroupService,
  ) {}

  private transformItem(item: RouteGroupAttributes) {
    return {
      name: get(item, 'name', '??'),
      company: get(item, 'company.name', '??'),
      statusId: this.getStatus(get(item, 'statusId', '')),
    };
  }

  private getStatus(value: string | number): string {
    if(!value && value !== 0) {
        return '';
    }
    return value === 1 ? 'Activo' : 'Inactivo';
  }

  export(format: ExportFileFormat, range: ExportRange, totalItems: number, pageSize: number, pageIndex: number) {
    const totalPages = ceil(totalItems / pageSize) + 1;
    this.exportService.task({
      id: ROUTE_GROUP_EXPORT_ID,
      title: ROUTE_GROUP_TITLE,
      format: format,
      iterations: range === ExportRange.AllPages ? totalPages : 1,
      start: (ctx: ExportContext) => {
        ctx.processor.localizeItemProperties(ROUTE_GROUP_TITLE, LOCALIZED_PROPERTIES);
      },
      next: (ctx: ExportContext) => {
        const currentPage = range === ExportRange.AllPages ? ctx.iteration : pageIndex;
        this.routeGroupService.findByFilter(buildQuery(
          seed(this.routeGroupService.currentFilter), page(currentPage, pageSize)
        ), { contextHeader: 'export' }).pipe(takeUntil(ctx.stopped)).subscribe((response) => {
          get(response, 'data.0.data', []).map((item) => {
            ctx.processor.addToSection(ROUTE_GROUP_TITLE, this.transformItem(item));
          });
          ctx.next();
        });
      },
    }).start();
  }

  canStartTask() {
    if (this.exportService.taskIsActive(ROUTE_GROUP_EXPORT_ID)) {
      this.exportService.setVisible(true);
      return false;
    }
    return true;
  }
}
